import CrudActionSetBase from './CrudActionSetBase'

export class PaymentActionSet extends CrudActionSetBase('payment'){}
export default new PaymentActionSet()